export default {
  slots: {
    identity: {
      label: 'ID document',
      hint: "ID card, passport or residence permit, front and back. Your partners' IDs go here too.",
    },
    trade_registration: {
      label: 'Business registration (Gewerbeanmeldung)',
      hint: 'The business registration you received from your trade office.',
    },
    commercial_register_extract: {
      label: 'Commercial register extract (Handelsregisterauszug)',
      hint: 'A current extract from the commercial register, if your business is registered there.',
    },
    bank_statement: {
      label: 'Bank statement (Kontoauszug)',
      hint: 'A recent statement of your business account that shows the account holder and the IBAN.',
    },
    shareholder_list: {
      label: 'List of shareholders (Gesellschafterliste)',
      hint: 'The current list of shareholders.',
      hint_gbr: 'Your partnership agreement (Gesellschaftsvertrag) or a list of all partners.',
    },
    tax_number: {
      label: 'Tax number or VAT ID (Steuernummer oder USt-IdNr.)',
      hint: 'A letter from the tax office that shows your tax number, or the confirmation of your VAT ID.',
    },
  },
  tags: {
    required: 'Required',
    optional: 'Optional',
    missing: 'Missing',
  },
  kinds: {
    passport: 'Passport',
    driver_license: "Driver's license",
    id_card: 'ID card',
    residence_permit: 'Residence permit',
  },
  holders: {
    owner: 'Owner',
    partner: 'Partner: {{name}}',
  },
  file: {
    with_back: 'Front and back',
    uploaded_at: 'Uploaded {{date}}',
    expires_at: 'Valid until {{date}}',
  },
  errors: {
    load: "Couldn't load the documents.",
  },
  empty: 'No file yet',
  buttons: {
    add: 'Add file',
    replace: 'Replace',
    remove: 'Remove',
    retry: 'Try again',
  },
  remove_confirm: {
    title: 'Remove this file?',
    description: 'Use this for a file you uploaded by mistake.',
    ok: 'Remove',
    cancel: 'Cancel',
  },
  toasts: {
    remove_success: 'File removed',
    remove_error: 'The file could not be removed. Please try again.',
  },
};
